import React from 'react';
import './PageLoader.css';

export function LoadingSpinner({ size = 32 }) {
  return <svg className="mitus-page-loader__spinner" width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true" focusable="false">
    <circle cx="16" cy="16" r="13" stroke="currentColor" strokeWidth="2.5" opacity=".18" />
    <path d="M16 3a13 13 0 0 1 13 13" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
  </svg>;
}

/** Silent visual loading state; the status name remains available to screen readers. */
export default function PageLoader({ fullScreen = false }) {
  return <div className={`mitus-page-loader${fullScreen ? ' mitus-page-loader--fullscreen' : ''}`} role="status" aria-label="Loading" aria-live="polite">
    <LoadingSpinner />
  </div>;
}
